// extracted by mini-css-extract-plugin
export default {"layout":"w0K2r","container":"p34WQ","inner":"LzKoF","main":"XZdGM"};